import { Fold, Lens, Traversal } from "@discovery/prelude/lib/control/lens";
import * as M from "@discovery/prelude/lib/data/maybe";
import { _Link2LinkedContentRoutes, _LinkGetter, } from "@discovery/sonic-api-ng-optics-gen/lib/link";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
export * from "@discovery/sonic-api-ng-optics-gen/lib/link";
const _ExternalLinks = Fold.compose(_LinkGetter, Res._Response(), Traversal._filtered((x) => x.attributes.kind === "External Link"), Lens.path("attributes", "href"), M._Just());
export const _InternalLinks = Fold.compose(_Link2LinkedContentRoutes, Res._Response(), Traversal._filtered((route) => route.attributes.canonical), Lens.path("attributes", "url"));
export const _LinkHref = Fold.concat(_InternalLinks, _ExternalLinks);

